import { Chip } from '@material-ui/core'
import { lightgreye3, midGray } from 'shared/theme/colors'

import { CTINLLCMCNumber } from 'helpers/constants'
import { getProductNameFromRecord } from 'helpers/utils'

export const ProductChip = ({ record }: any) => {
  var style: any = {
    marginLeft: '5px',
    verticalAlign: 'text-top',
  }
  const isCTIN = record?.product_subscription?.carrier?.mc_number === CTINLLCMCNumber
  if (isCTIN) {
    style = {
      ...style,
      color: midGray,
      backgroundColor: lightgreye3,
      border: `1px solid ${midGray}`,
    }
  } else {
    style = {
      ...style,
      color: 'white',
      backgroundColor: '#555962',
    }
  }
  return <Chip label={getProductNameFromRecord(record, true)} style={style} />
}
